import React, { useState } from 'react'
import style from './TodoFrom.module.css';

function TodoForm({addTodo}) {
    const [value,setValue]=useState("");
    const handleSubmit=(e)=>{
        e.preventDefault();
        if(value){
            addTodo(value);
            setValue("");
        }
    }
  return (
    <form onSubmit={handleSubmit} className={style.todoform}>
        <input type='text'
        value={value}
        onChange={(e)=>{setValue(e.target.value)}}
        className={style.todo_input}
        placeholder='What is The Task Today?'    
        />

        <button type='submit' className={style.todo_btn}>Add Task</button>
    </form>
  )
}

export default TodoForm